export default "__VITE_ASSET__COGCJUBZ__"